import type { ProgressiveFormStateImplementor } from '@innogy/progressive-ngrx-forms';
import {
  createProgressiveFormGroupState,
  createProgressiveNgrxFormReducerWithFormStateUpdate,
} from '@innogy/progressive-ngrx-forms';
import { setValue, updateGroup } from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';
import type { Action, ActionReducer } from '@ngrx/store';
import { on } from '@ngrx/store';
import {
  isFriendlyFormatIBAN,
  validateSequential,
} from '@innogy/utils-deprecated';
import { getPaymentDetailsSuccess } from '@essent/financial';
import { paymentDetailsFormId } from '@innogy/emobility-shared';

export interface LeadFormsPaymentDetailsFormValues {
  iban: string;
}

export interface LeadFormsPaymentDetailsFormState
  extends ProgressiveFormStateImplementor<LeadFormsPaymentDetailsFormValues> {}

export const initialPaymentDetailsFormState =
  createProgressiveFormGroupState<LeadFormsPaymentDetailsFormValues>(
    paymentDetailsFormId,
    {
      iban: '',
    }
  );

export const initialPaymentDetailsState: LeadFormsPaymentDetailsFormState = {
  progressiveForm: initialPaymentDetailsFormState,
};

export function validatePaymentDetailsForm(
  state: LeadFormsPaymentDetailsFormState
) {
  return updateGroup<LeadFormsPaymentDetailsFormValues>({
    iban: validateSequential(required, isFriendlyFormatIBAN),
  })(state.progressiveForm.formState);
}

export const _reducer: ActionReducer<LeadFormsPaymentDetailsFormState> =
  createProgressiveNgrxFormReducerWithFormStateUpdate(
    initialPaymentDetailsState,
    validatePaymentDetailsForm,
    on(getPaymentDetailsSuccess, (state, action) => {
      const formState = setValue(state.progressiveForm.formState, {
        ...state.progressiveForm.formState.value,
        iban: action.payload.paymentDetails.iban ?? '',
      });

      return {
        ...state,
        progressiveForm: {
          ...state.progressiveForm,
          formState,
        },
      };
    })
  );

export function leadFormPaymentDetailsReducer(
  state: LeadFormsPaymentDetailsFormState = initialPaymentDetailsState,
  action: Action
) {
  return _reducer(state, action);
}
